export const useRefreshAccessToken = async (refreshToken) => {
  if (!refreshToken) {
    throw new Error('Refresh token is missing');
  }

  const config = useRuntimeConfig();
  const result = await useApi().post(
    `${config.public.apiUrl}/api/login/refresh/`,
    { refresh: refreshToken },
    { skipAuthRefresh: true, skipAuthHeader: true }
  );

  if (result?.error || !result?.access) {
    throw new Error('Refresh token is invalid or expired');
  }

  return result.access;
}
